
import { CardType } from '@/types/Card'
import { defineComponent, reactive, watchEffect } from 'vue'
import ExchangeIcon from '@/components/Icons/ExchangeIcon.vue'
import VisaIcon from '@/components/Icons/VisaIcon.vue'
import MastercardIcon from '@/components/Icons/MastercardIcon.vue'
import ChipIcon from '@/components/Icons/ChipIcon.vue'

export default defineComponent({
  name: 'NewCard',
  components: {
    ExchangeIcon,
    VisaIcon,
    MastercardIcon,
    ChipIcon,
  },
  emits: ['add'],
  setup(props, { emit }) {
    const card = reactive<CardType>({
      num: '1234123412341234',
      category: 'visa',
      owner: 'John D.',
      expiration: '01/22',
    })

    const formatNumber = () => {
      card.num = card.num
        .replace(/[^0-9.]/g, '')
        .replace(/(.{4})/g, '$1 ')
        .trim()
    }

    const formatExpiration = () => {
      card.expiration = card.expiration
        .replace(/[^0-9.]/g, '')
        .replace(/(.{2})/g, '$1/')
        .slice(0, -1)
    }

    watchEffect((card) => {
      formatNumber()
      formatExpiration()
    })

    const addCard = () => {
      emit('add', card)
    }

    return {
      card,
      addCard,
    }
  },
})
